<div
    [style.display]="selected ? '' : 'none'"
    role="tabpanel"
    [id]="id + '.panel'"
    [attr.aria-labelledby]="id"
>
    <agpr-entity-details
        #entityDetails
        [id]="id + '_contactDetails'"
        [entityType]="entityType"
        [sidebar]="rhp"
        [syncOutletTabInfo]="syncOutletTabInfo"
        [disableFullProfile]="disableFullProfile"
        [fullHeightProfileTakeover]="fullHeightProfileTakeover"
        [hiddenNoContentMessage]="hiddenNoContentMessage"
        [noContactMessage]="noContactMessage"
        [noOutletMessage]="noOutletMessage"
    ></agpr-entity-details>
    <ng-template #tabFooter>
        <agpr-action-bar
            *ngIf="selected && (targetingAccessLevel === targetingAccessLevels.ADVANCED) && showActions"
            [headingContext]="(entityType === entityTypes.CONTACT ? 'Discover.universal.contact' : 'Discover.universal.outlet') | localize"
            [headingLevel]="4"
        >
            <ng-template #right>
                <agpr-split-button
                    *ngIf="actions"
                    [id]="id + '_outletBusinessCard_actions'"
                    [label]="'Discover.targeting.actions.actions' | localize"
                    [style]="buttonTypes.tertiary"
                    [options]="actions"
                    [panelPositionY]="'top'"
                    [panelPositionX]="'right'"
                ></agpr-split-button>
            </ng-template>
        </agpr-action-bar>
    </ng-template>
</div>
